import { render, staticRenderFns } from "./NewSkillSupply.vue?vue&type=template&id=378e5da6&scoped=true&"
import script from "./NewSkillSupply.vue?vue&type=script&lang=ts&"
export * from "./NewSkillSupply.vue?vue&type=script&lang=ts&"
import style0 from "./NewSkillSupply.vue?vue&type=style&index=0&id=378e5da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378e5da6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VPagination,VProgressCircular,VRow})
